import { REG_PLACEHOLDER } from './Constants';

export interface IDataMap {
    [key: string]: string | number;
}

export const getPlaceholders = (template: string): RegExpMatchArray | null =>
    template.match(REG_PLACEHOLDER);

export const getFormattedText = (template: string, values: IDataMap): string => {
    const placeholders: string[] = getPlaceholders(template) || [];

    return placeholders.reduce((acc: string, curr: string) => {
        const key = curr.replace(/:/g, '');
        const replacedValue = values[key] || '';
        const replacedUrl = acc.replace(curr, replacedValue.toString());

        return replacedUrl;
    }, template);
};
